import api from "../api";

export const fetchEmployeeInformation = async (
  employeeID: string,
  userAccountID: string,
) => {
  return await api.get(
    `/Employee/EmployeeID/${employeeID}/UserAccountID/${userAccountID}`,
  );
};
